import { isLocationCity } from './isLocationCity'
import { locationHasParentLocation } from './locationHasParentLocation'

export const getParentLocationForCityTypeOrDefaultToTitle = (
  location = { parentLocation: '', type: '', title: '' }
) => {
  const locationTitle =
    isLocationCity(location) && locationHasParentLocation(location)
      ? location.parentLocation
      : location.title

  return locationTitle || ''
}
